import Immutable from 'immutable';
import webapi from '../../webapi';
import { createModuleState } from '../moduleregistry';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('SimpleDefinition');
const EMPTY_LIST = Immutable.List([]);

export const errorPath = ['tmp', 'errors'];
export const errorMessageListPath = ['tmp', 'errorMessages'];
const originalErrorPath = ['tmp', 'originalErrors'];

var getProperty = function(imObj, path) {
	if (Array.isArray(path)) {
		return imObj.getIn(path);
	} else {
		return imObj.get(path);
	}
};

var setProperty = function(imObj, path, value) {
	if (Array.isArray(path)) {
		return imObj.setIn(path, value);
	} else {
		return imObj.set(path, value);
	}
};


export default class SimpleDefinitionModel {
	#data;

	constructor(data = null) {
		this.#data = data || EMPTY_MAP;
	}

	getData() {
		return this.#data;
	}

	setAsBaseState() {
		const data = this.#data;
		return new SimpleDefinitionModel(data.set('_baseData', data.delete('_baseData')));
	}

	static getBaseStatePath(path) {
		return ['_baseData'].concat(path);
	}

	setInBaseState(key, value) {
		const data = this.#data;
		const baseData = (data.get('_baseData') || EMPTY_MAP).set(key, value);
		return new SimpleDefinitionModel(data.set('_baseData', baseData));
	}


	reset() {
		return new SimpleDefinitionModel(this.#data.get('_baseData')).setAsBaseState();
	}

	setProperty(path, value) {
		return new SimpleDefinitionModel(setProperty(this.#data, path, value));
	}

	getProperty(path) {
		return getProperty(this.#data, path);
	}

	setDefinition(definition) {
		return new SimpleDefinitionModel(this.#data.set('definition', definition));
	}

	setCalculateContextProperties(ccp) {
		return new SimpleDefinitionModel(this.#data.set('calculateContextProperties', ccp));
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}
